export const StorefrontImage = () => (
  <div className="mt-16 mb-8 flex flex-col items-center">
    <img
      src="https://kjfwyaniengzduyeeufq.supabase.co/storage/v1/object/public/logos/klatsch-door.png"
      alt="The Klatsch Door"
      className="w-1/4 h-auto object-cover rounded-lg shadow-md max-w-[240px]"
    />
  </div>
);
